// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weight-question .weight-question-inputs {
    display: flex;
    justify-content: left;
    align-items: center;
}

.weight-question .weight-question-input {
    width: 70px;
}

.weight-question .weight-question-inline-label {
    padding-right: 20px;
    padding-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Questions/WeightQuestion/WeightQuestion.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":[".weight-question .weight-question-inputs {\n    display: flex;\n    justify-content: left;\n    align-items: center;\n}\n\n.weight-question .weight-question-input {\n    width: 70px;\n}\n\n.weight-question .weight-question-inline-label {\n    padding-right: 20px;\n    padding-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
